<template>
  <v-container class="d-flex justify-center">No property.</v-container>
</template>

<script>
export default {
  name: "LogoffDesigner",
  
  builder: {
    cat: "Route",
    type: "Logoff",

    init: function(instance) {},

    getDesc: function(instance) {
      return "Logoff";
    }
  }
};
</script>
